const localKeywordsRegex =
  /(^|\s|\()(filecount|processing-status|submission-time|submission-user|tag-user):/i;

const cloudKeywordsRegex = /(^|\s|\()(in\s*:\s*false|available\s*:\s*false)/i;

const LOCAL_KEYWORDS = ["processing-status", "submission-user"];

const CLOUD_KEYWORDS = ["cloud_search_type"];

export {
  CLOUD_KEYWORDS,
  cloudKeywordsRegex,
  LOCAL_KEYWORDS,
  localKeywordsRegex
};
